import { render, staticRenderFns } from "./updatePTMMO.vue?vue&type=template&id=00c8ef9e&lang=pug&"
import script from "./updatePTMMO.vue?vue&type=script&lang=js&"
export * from "./updatePTMMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports